import React from 'react';
import { PaymentLogo } from '../PaymentLogo';

export function ApplePayButton({ onClick, disabled }) {
  return (
    <button
      type="button"
      className="w-100 p-12 rounded-2 nc-realtextpro-copy fw-bold bg-black border-0 d-flex justify-content-center align-items-center"
      onClick={onClick}
      disabled={disabled}
    >
      <PaymentLogo icon="iconApplePayLight" bgClassName="" ariaLabel="Apple Pay" width={75} height={20}/>
    </button>
  );
}

export default ApplePayButton;
